export default {
  editMode: (state) => state.editMode,
  unsavedChanges: (state) => state.unsavedChanges,
  warningContext: (state) => state.warningContext,
  warning: (state) => state.warning,
  snackbarContext: (state) => state.snackbarContext,
  snackbar: (state) => state.snackbar,
};
